

/* ===== VELANTIS_PRODUCT_PAGE — página de producto por ruta #/p/<nombre> ===== */

(function(){

  var page=document.getElementById('productoPage'); if(!page) return;

  var VIDEOS=["//velantis.mx/cdn/shop/t/25/assets/1e388a11-4f48-4868-89ba-c3867aa19c6f.mp4?v=131553139599236249341788483471","//velantis.mx/cdn/shop/t/25/assets/2b1c7add-eaee-4a29-bf29-676d98d330d9.mp4?v=183733152132890300141788483472","//velantis.mx/cdn/shop/t/25/assets/438d5b26-a4ea-4cca-9fd9-d82417bf582d.mp4?v=168789943529465084561788483472","//velantis.mx/cdn/shop/t/25/assets/6cc7cb83-6f71-411f-9c15-6f9ba79c1972.mp4?v=166668219582710629401788483473","//velantis.mx/cdn/shop/t/25/assets/7bed809a-7a90-4429-9717-edb1a24b06cb.mp4?v=171657212262141319631788483474","//velantis.mx/cdn/shop/t/25/assets/9367e968-5283-4727-81da-eaadc7ec1570.mp4?v=183989277549400804691788483475","//velantis.mx/cdn/shop/t/25/assets/dd39620f-cb4d-48ce-8763-7d610e82b1a0.mp4?v=141235027877998908441788483489","//velantis.mx/cdn/shop/t/25/assets/f255e6d7-73d3-4a60-a936-a28e21d777b6.mp4?v=13953602226499906491788483497"];

  function CAT(){ return window.VELANTIS_CAT||[]; }

  function de(s){return String(s).normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();}

  function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}

  function cap(s){return s?s.charAt(0).toUpperCase()+s.slice(1):'';}
    /* 3-sep: el titulo de la ficha dice «Inspirado en Fico Di Amalfi, de Acqua
       di Parma». El codigo (V007) sigue arriba, pintado desde data-sku, y el
       nombre crudo queda en data-nombre para que el codigo se resuelva igual. */
    function bonito(s){ return String(s||'').toLowerCase().replace(/(^|[\s\-\/(])([a-záéíóúñü])/g,function(m,a,b){return a+b.toUpperCase();}); }
    function tituloFicha(nombre,casa){ return casa ? ('Inspirado en '+bonito(nombre)+', de '+casa) : bonito(nombre); }

  function tc(s){return s.toLowerCase().replace(/(^|[\s'&-])([a-záéíóúñ])/g,function(m,a,b){return a+b.toUpperCase();});}

  function first3(s){ if(!s)return''; var a=s.split(', ').slice(0,3); return a.length>1?a.slice(0,-1).join(', ')+' y '+a[a.length-1]:a[0]; }

  function pyr(r){return [r[5],r[6],r[7]].filter(Boolean).join(', ');}

  function nameKey(r){ return de(r[0]); }

  function hash(s){var x=2166136261;for(var i=0;i<s.length;i++){x^=s.charCodeAt(i);x=Math.imul(x,16777619);}return x>>>0;}

  var SOLD=[500,650,800,1000,1300,1700,2200,3000];



  function describe(r){

    var amb=r[1]==='Ambiental';

    var quien={Dama:'para ella',Caballero:'para él',Unisex:'unisex',Ambiental:'para tu espacio'}[r[1]]||'unisex';

    var fam=(r[3]&&r[3]!=='Otras')?r[3].toLowerCase():'';

    var tipo=amb?'Aroma de ambiente':'Fragancia';

    var out=[ fam?tipo+' de familia '+fam+', '+quien+'.':tipo+' '+quien+'.' ];

    var p=[];

    if(r[5])p.push('abre con '+first3(r[5]));

    if(r[6])p.push('evoluciona hacia '+first3(r[6]));

    if(r[7])p.push('reposa sobre '+first3(r[7]));

    if(p.length){ var fr=p.length>1?p.slice(0,-1).join(', ')+' y '+p[p.length-1]:p[0]; out.push(cap(fr)+'.'); }

    else if(r[8]) out.push(cap(r[8]));

    if(r[2]) out.push((amb?'Inspirado':'Inspirada')+' en '+tc(r[0])+' de '+r[2]+'.');

    if(!amb) out.push('Elixir de Parfum de alta concentración y larga duración.');

    out.push('Con feromonas incluidas.');

    return out.join(' ');

  }



  function findRow(name){

    var c=CAT(), key=de(name);

    for(var i=0;i<c.length;i++){ if(c[i][0]===name) return c[i]; }

    for(var j=0;j<c.length;j++){ if(de(c[j][0])===key) return c[j]; }

    return null;

  }

  function similar(r){

    var c=CAT(), out=[];

    for(var i=0;i<c.length;i++){ if(c[i]!==r && c[i][4]===r[4]) out.push(c[i]); if(out.length>=8) break; }

    if(out.length<6){ for(var j=0;j<c.length;j++){ if(c[j]!==r && c[j][9]===r[9] && out.indexOf(c[j])<0) out.push(c[j]); if(out.length>=8) break; } }

    return out.slice(0,6);

  }



  /* ---- carrusel de video reutilizable (coverflow) ---- */

  function mountVideos(root){

    if(!root || root._mounted || !VIDEOS.length) return; root._mounted=true;

    var track=root.querySelector('.rv-track'), vp=root.querySelector('.rv-viewport'),

        prev=root.querySelector('.rv-arrow.prev'), next=root.querySelector('.rv-arrow.next'),

        dots=root.querySelector('.rv-dots');

    var idx=Math.floor(VIDEOS.length/2), vids=[], soundOn=false;

    var OFF='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16 9l4 6M20 9l-4 6" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

    var ON='<svg viewBox="0 0 24 24"><path d="M4 9v6h4l5 4V5L8 9H4z"/><path d="M16.5 8.5a5 5 0 010 7M19 6a9 9 0 010 12" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';

    track.innerHTML=VIDEOS.map(function(src,i){ return '<div class="rv-slide" data-i="'+i+'"><div class="rv-card"><video class="rv-video" preload="none" muted loop playsinline webkit-playsinline src="'+src+'"></video><div class="rv-grad"></div><div class="rv-hint">Toca para escuchar</div><button class="rv-sound" type="button">'+OFF+'</button></div></div>'; }).join('');

    vids=[].slice.call(track.querySelectorAll('.rv-video'));

    dots.innerHTML=VIDEOS.map(function(_,i){ return '<button class="rv-dot'+(i===idx?' on':'')+'" type="button" data-i="'+i+'"></button>'; }).join('');

    function warm(){ var nb={}; [idx-1,idx+1].forEach(function(k){nb[(k+VIDEOS.length)%VIDEOS.length]=1;});

      vids.forEach(function(v,i){ if(i===idx){v.preload='auto';} else if(nb[i]){v.preload='auto'; if(v.readyState<2){try{v.load();}catch(_){}}} else {v.preload='none';} }); }

    function icon(){ var b=track.children[idx].querySelector('.rv-sound'); if(b) b.innerHTML=soundOn?ON:OFF; }

    function center(anim){ var s=track.children[idx]; if(!s)return; track.style.transition=anim===false?'none':'';

      track.style.transform='translateX('+(vp.clientWidth/2-(s.offsetLeft+s.offsetWidth/2))+'px)';

      [].forEach.call(track.children,function(sl,i){ var d=Math.abs(i-idx),c=sl.querySelector('.rv-card');

        c.style.transform='scale('+Math.max(.6,1-d*.13)+')'; c.style.opacity=String(Math.max(.26,1-d*.34)); c.style.zIndex=String(100-d); sl.classList.toggle('active',i===idx); });

      [].forEach.call(dots.children,function(d,i){d.classList.toggle('on',i===idx);});

      warm(); vids.forEach(function(v,i){ if(i===idx){v.muted=!soundOn; var p=v.play(); if(p&&p.catch)p.catch(function(){});} else {try{v.pause();}catch(_){}; v.muted=true;} }); icon(); }

    function go(i){ idx=(i%VIDEOS.length+VIDEOS.length)%VIDEOS.length; center(true); }

    prev.addEventListener('click',function(){go(idx-1);}); next.addEventListener('click',function(){go(idx+1);});

    dots.addEventListener('click',function(e){var b=e.target.closest('.rv-dot'); if(b)go(+b.dataset.i);});

    function setSound(on){ soundOn=on; root.classList.toggle('sound-on',on); var v=vids[idx]; if(v){v.muted=!on; if(on){var p=v.play(); if(p&&p.catch)p.catch(function(){});}} icon(); }

    var sx=0,sy=0,dx=0,drag=false,moved=false,w=0,bx=0,dt=null;

    vp.addEventListener('pointerdown',function(e){drag=true;moved=false;w=vp.clientWidth;sx=e.clientX;sy=e.clientY;dx=0;dt=e.target;var m=track.style.transform.match(/-?[\d.]+/);bx=m?parseFloat(m[0]):0;track.style.transition='none';try{vp.setPointerCapture(e.pointerId);}catch(_){}});

    vp.addEventListener('pointermove',function(e){if(!drag)return;dx=e.clientX-sx;if(Math.abs(dx)>6||Math.abs(e.clientY-sy)>6)moved=true;if(moved)track.style.transform='translateX('+(bx+dx)+'px)';});

    function endp(){ if(!drag)return;drag=false; if(moved){ if(Math.abs(dx)>w*.1){dx<0?go(idx+1):go(idx-1);}else{center(true);} return;} var sl=dt&&dt.closest?dt.closest('.rv-slide'):null; if(sl){var i=+sl.dataset.i; if(i!==idx)go(i); else setSound(!soundOn);} }

    vp.addEventListener('pointerup',endp); vp.addEventListener('pointercancel',endp);

    root.classList.add('in'); center(false); requestAnimationFrame(function(){center(false);});

    root._pause=function(){ vids.forEach(function(v){try{v.pause();}catch(_){}}); };

    root._resume=function(){ center(true); };

  }



  /* ---- acordeón ---- */

  function buildAccordion(r){

    var envSub='Envíos a todo México · Devoluciones gratis.';

    var items=[

      {t:'Acerca', body:'<p>'+esc(describe(r))+'</p><p>Concentración <b>Elixir de Parfum</b> (~30% de aceites): proyección notable y <b>8–12 h</b> de duración en piel.</p>'},

      {t:'Envíos + Devoluciones', s:envSub, body:'<p>Enviamos a <b>todo México</b>. <b>Envío normal</b>: 5–7 días hábiles · <b>Envío express</b>: 1–3 días hábiles. Envío <b>gratis</b> en compras a partir de $1,200.</p><p>Cambios y <b>devoluciones sin costo</b> dentro de los primeros 30 días si el producto no fue abierto.</p>'},

      {t:'FAQs', body:'<p><b>¿Son originales?</b> Son fragancias inspiradas en las grandes casas, con aceites de alta calidad — no son los originales de marca.</p><p><b>¿Cuánto duran?</b> Al ser Elixir de Parfum, entre 8 y 12 horas según tu piel.</p><p><b>¿Tienen garantía de aroma?</b> Sí, si no te convence el aroma te ayudamos a encontrar otro.</p>'}

    ];

    // "Mejor combinación" solo para perfumes personales — NO para ambientales

    /* "Mejor combinación" removido: ahora se presenta con el botón Layering */

    return items.map(function(it){

      return '<div class="acc-item"><button class="acc-head" type="button"><span><span class="acc-t">'+esc(it.t)+'</span>'+(it.s?'<span class="acc-s">'+esc(it.s)+'</span>':'')+'</span><span class="acc-ic">&#8964;</span></button><div class="acc-body"><div class="acc-body-inner">'+it.body+'</div></div></div>';

    }).join('');

  }

  function bestCombo(r){

    // sugiere una fragancia de familia distinta para capas + un tip

    var c=CAT(), alt=null;

    for(var i=0;i<c.length;i++){ if(c[i][4]!==r[4] && c[i][1]===r[1]){ if(hash(r[0]+c[i][0])%7===0){ alt=c[i]; break; } if(!alt) alt=c[i]; } }

    var tip='Para intensificar tu '+tc(r[0])+', aplica primero en las muñecas y el cuello, y guarda el frasco lejos del calor.';

    if(alt) return '<p>'+tip+'</p><p>Combínala (layering) con <b>'+esc(tc(alt[0]))+'</b>'+(alt[2]?' (inspirado en '+esc(alt[2])+')':'')+' para un rastro más personal y difícil de olvidar.</p>';

    return '<p>'+tip+'</p>';

  }



  /* ---- render de similares y reseñas de texto ---- */

  var QUOTES=[

    ['El aroma dura todo el día y recibo cumplidos siempre.','María G.'],

    ['Huele igualito a la fragancia original, calidad increíble.','Jorge L.'],

    ['La atención es de otro nivel, me ayudaron a elegir.','Ana P.'],

    ['Compré tres y ya voy por más, valen cada peso.','Luis M.'],

    ['Excelente para regalo, la presentación es hermosa.','Sofía R.'],

    ['Proyecta muchísimo, con dos aplicaciones basta.','Diego H.']

  ];

  function renderText(){

    document.getElementById('ppText').innerHTML=QUOTES.map(function(q){

      return '<div class="pp-tr"><div class="stars">★★★★★</div><p>“'+esc(q[0])+'”</p><div class="who">— '+esc(q[1])+'</div></div>';

    }).join('');

  }

  function renderSimilar(r){

    var grid=document.getElementById('ppSim');

    grid.innerHTML=similar(r).map(function(s){

      return '<article class="pp-simcard" data-name="'+esc(s[0])+'" data-price="'+(s[11]||389)+'" data-img="n-'+esc(s[9])+'" data-sub="'+esc(s[3])+'"><div class="pp-simimg n-'+esc(s[9])+'"></div>'+

        '<div class="pp-simbody"><span class="fam">'+esc(s[3])+'</span><h4>'+esc(s[0])+'</h4>'+

        (s[2]?'<span class="insp">Inspirado en · '+esc(s[2])+'</span>':'')+'<span class="pr">'+(s[1]==='Ambiental'?('$'+(s[11]||389)):('$'+(s[11]||499)+''))+' MXN</span>'+

        '<button class="add" type="button">Agregar al carrito</button></div></article>';

    }).join('');

  }



  /* ---- poblar la página ---- */

  var fallback=null;   // datos de tarjetas curadas que no están en el catálogo

  function populate(name){

    var r=findRow(name);

    if(!r){

      var fb=fallback && de(fallback.name)===de(name) ? fallback : {name:name,sub:'',img:'',house:''};

      document.getElementById('ppImg').className='pp-img '+(fb.img||'');

      document.getElementById('ppFam').textContent=fb.sub||'';

      document.getElementById('ppName').dataset.nombre=fb.name; document.getElementById('ppName').textContent=tituloFicha(fb.name,fb.house);

      var hh=document.getElementById('ppHouse'); hh.textContent=''; hh.hidden=true;

      document.getElementById('ppDesc').textContent=(fb.sub?('Fragancia de familia '+fb.sub.toLowerCase()+'. '):'')+'Elixir de Parfum de alta concentración y larga duración.';

      document.getElementById('ppPyr').innerHTML='';

      var info0=document.getElementById('ppInfo'); info0.dataset.name=fb.name; info0.dataset.img=fb.img; info0.dataset.sub=fb.sub;

      social(fb.name); promos(); accordionGeneric(); renderText(); document.getElementById('ppSim').innerHTML='';

      mountVideos(document.getElementById('ppVideos')); resumeVideos(); window.scrollTo(0,0); return;

    }

    document.getElementById('ppImg').className='pp-img n-'+r[9];

    document.getElementById('ppFam').textContent=r[3]+' · '+r[1];

    document.getElementById('ppName').dataset.nombre=r[0]; document.getElementById('ppName').textContent=tituloFicha(r[0],r[2]);

    var hEl=document.getElementById('ppHouse'); hEl.textContent=''; hEl.hidden=true; /* la casa ya va en el titulo */

    document.getElementById('ppDesc').textContent=describe(r);

    document.getElementById('ppPyr').innerHTML=row('Salida',r[5])+row('Corazón',r[6])+row('Fondo',r[7]);

    var info=document.getElementById('ppInfo'); info.dataset.name=r[0]; info.dataset.img='n-'+r[9]; info.dataset.sub=r[3]; info.dataset.price=String(r[11]||389);

    var ppPriceEl=page.querySelector('.pp-price'); var _ppMl=document.getElementById('ppMl'); if(_ppMl){_ppMl.style.display='inline-block';_ppMl.textContent=(r[1]==='Ambiental'?'250 ml':'');} var _ppFero=document.getElementById('ppFero'); if(_ppFero)_ppFero.style.display=(r[1]==='Ambiental'?'none':'block'); var _ppEl=document.getElementById('ppEleva'); if(_ppEl){ _ppEl.style.display=(r[1]==='Ambiental'?'none':'block'); _ppEl.setAttribute('href','#/eleva/'+encodeURIComponent(r[0])); } if(ppPriceEl) ppPriceEl.innerHTML=(r[1]==='Ambiental'?('$'+(r[11]||389)):('$'+(r[11]||590)+''))+' MXN';

    social(r[0]); promos();

    document.getElementById('ppAcc').innerHTML=buildAccordion(r); wireAccordion();

    renderText(); renderSimilar(r);

    mountVideos(document.getElementById('ppVideos')); resumeVideos();

    window.scrollTo(0,0);

  }

  function row(label,val){ return val?'<div class="pp-row"><span>'+label+'</span><p>'+esc(cap(val))+'</p></div>':''; }

  function social(name){

    var hv=hash(name), rating=4.9, reviews=340, sold=500, units=6;

    document.getElementById('ppSocial').innerHTML='<span class="pp-stars">★★★★★</span><span class="pp-rating-num">'+rating.toFixed(1)+'</span><span class="pp-reviews">('+reviews+' reseñas)</span><span class="pp-sold"><b>+'+sold+'</b> vendidos</span>';

    document.getElementById('ppUrgency').innerHTML='<span class="dot"></span> Pocas unidades · quedan <b>'+units+'</b>';

  }

  function promos(){

    document.getElementById('ppPromo').innerHTML=

      '<button type="button" class="promo"><span class="tag">3×2</span><span class="txt"><b>Llévate 3, paga 2</b>Mezcla y combina fragancias</span><span class="promo-add">Elegir →</span></button>'+

      '<button type="button" class="promo"><span class="tag">4×3</span><span class="txt"><b>Llévate 4, paga 3</b>Mezcla y combina fragancias</span><span class="promo-add">Elegir →</span></button>';

  }

  function accordionGeneric(){

    document.getElementById('ppAcc').innerHTML=buildAccordion({0:(document.getElementById('ppName').dataset.nombre||document.getElementById('ppName').textContent),1:'Unisex',2:'',3:document.getElementById('ppFam').textContent,4:'',5:'',6:'',7:'',8:'',9:''}); wireAccordion();

  }

  function wireAccordion(){

    [].forEach.call(document.querySelectorAll('#ppAcc .acc-item'),function(it){

      var head=it.querySelector('.acc-head'), body=it.querySelector('.acc-body');

      head.addEventListener('click',function(){

        var open=it.classList.contains('open');

        if(open){ it.classList.remove('open'); body.style.maxHeight='0'; }

        else { it.classList.add('open'); body.style.maxHeight=body.firstElementChild.scrollHeight+40+'px'; }

      });

    });

  }

  function resumeVideos(){ var v=document.getElementById('ppVideos'); if(v&&v._resume) v._resume(); }

  function pauseVideos(){ var v=document.getElementById('ppVideos'); if(v&&v._pause) v._pause(); }



  /* opciones de envío (selección visual) */

  var shipWrap=document.getElementById('ppShip');

  if(shipWrap) shipWrap.addEventListener('click',function(e){

    var b=e.target.closest('.pp-shipbtn'); if(!b) return;

    [].forEach.call(shipWrap.children,function(c){ c.classList.remove('active'); });

    b.classList.add('active');

  });



  /* ---- ir a producto ---- */

  function canonical(name){ var r=findRow(name); return r?r[0]:name; }

  function goToProduct(name,fb){ if(fb) fallback=fb; location.hash='#/p/'+encodeURIComponent(canonical(name)); }

  window.VelantisProducto={ open:goToProduct };



  /* Interceptar clic en cualquier tarjeta de producto (fase de captura) */

  document.addEventListener('click',function(e){

    if(e.target.closest('.add')) return;                 // agregar al carrito: no interceptar

    var card=e.target.closest('.cat-card,.card,.xf-rc,.pp-simcard');

    if(!card) return;

    var name=card.getAttribute('data-name'); if(!name) return;

    if(/^n-amb/.test(card.getAttribute('data-img')||'')){ e.preventDefault(); e.stopImmediatePropagation(); location.hash='#/lhs/'+encodeURIComponent('AMB:'+name); return; }

    e.preventDefault(); e.stopImmediatePropagation();

    var fb=null;

    if(!findRow(name)){ var insp=((card.querySelector('.insp,.cat-house,.pp-simbody .insp')||{}).textContent||''); var parts=insp.split('·'); fb={name:name,sub:card.getAttribute('data-sub')||'',img:card.getAttribute('data-img')||'',house:parts.length>1?parts[parts.length-1].trim():''}; }

    goToProduct(name,fb);

  },true);



  /* Redirigir también las aperturas programáticas (buscador global, etc.) */

  function wrapOpen(){ if(window.VelantisCatalogo && !window.VelantisCatalogo._ppWrapped){ window.VelantisCatalogo._ppWrapped=true; window.VelantisCatalogo.openByName=function(n){ goToProduct(n); return true; }; } }

  wrapOpen(); setTimeout(wrapOpen,0);



  /* ---- ruta ---- */

  document.getElementById('ppBack').addEventListener('click',function(){ if(history.length>1) history.back(); else location.hash='#/'; });



  /* Ofertas 3×2 / 4×3 (mezcla y combina): llevan al catálogo a elegir fragancias.

     El descuento se aplica solo en el carrito: cada 3 fragancias, 1 gratis. */

  document.getElementById('ppPromo').addEventListener('click',function(e){

    var b=e.target.closest('.promo'); if(!b) return;

    location.hash='#catalogo';

    setTimeout(function(){ var c=document.getElementById('catalogo'); if(c) c.scrollIntoView({behavior:'smooth'}); },70);

  });

  function onRoute(){

    var m=/^#\/p\/(.+)$/.exec(location.hash||'');

    if(m){ document.body.classList.add('producto'); page.hidden=false; populate(decodeURIComponent(m[1])); }

    else { if(document.body.classList.contains('producto')){ pauseVideos(); } document.body.classList.remove('producto'); page.hidden=true; }

  }

  window.addEventListener('hashchange',onRoute);

  onRoute();

})();

